import styles from './styles.module.sass';

const EmptyOfferSpacer = () => <div aria-hidden="true" className={styles.spacer} />;

export default EmptyOfferSpacer;
